const state = {
    items: {
        cartId: 0,
        token: null,
        confirmToken: null,
        paymentMethod: null,
        isReceiveEmail: false,
        counts: 0,
        promotionObj: {},
        useDateList: []
    }
}

const getters = {
    items: state => state.items
}

const mutations = {
    UPDATE_CART_ITEMS(state, payload) {
        state.items = payload;
    }
}

const actions = {
    updateItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            let cartItem = {};
            const vuex = window.sessionStorage.getItem("vuex");
            if (vuex !== null) {
                cartItem = JSON.parse(vuex).cart.items;
            }
            if (params.cartId != undefined)
                cartItem.cartId = params.cartId;
            if (params.token != undefined)
                cartItem.token = params.token;
            if (params.confirmToken != undefined)
                cartItem.confirmToken = params.confirmToken;
            if (params.paymentMethod != undefined)
                cartItem.paymentMethod = params.paymentMethod;
            if (params.isReceiveEmail != undefined)
                cartItem.isReceiveEmail = params.isReceiveEmail;
            if (params.counts != undefined)
                cartItem.counts = params.counts;
            if (params.promotionObj != undefined)
                cartItem.promotionObj = params.promotionObj;
            if (params.useDateList != undefined) {
                cartItem.useDateList = params.useDateList;
            }
            commit('UPDATE_CART_ITEMS', cartItem);
            console.log("commit");
            resolve();
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}